import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import { ShiftMap } from './shift_map';
import { useDispatch, useSelector } from 'react-redux';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getShiftStatus } from './shift_status';
import { formatDateOrdinal, formatDateTimeOrdinal } from './date_util';
import { ExcelButton } from './excel_button';
import { fetchAllShifts } from '../redux/reducers/shifts_reducer';


export const AppHome = () => {

  const dispatch = useDispatch();
  const clientData = useSelector(state => state.user.clientData);
  const rawColor = clientData && clientData.color ? clientData.color.trim() : '';
  const defaultPinColor = rawColor ? (rawColor.startsWith('#') ? rawColor : '#' + rawColor) : '#B7966A';

  const logoutUser = () => {
    dispatch({ type: 'LOG_OUT', payload: null });
    sessionStorage.setItem('currentUser', null);
    window.location = "/";
  };

  const navigate = useNavigate();
  const [shifts, setShifts] = useState([]);
  const [filteredShifts, setfilteredShifts] = useState([]);
  const [mapShifts, setMapShifts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchShifts();
  }, [])

  // Refresh map pins and table data every 5 minutes
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const response = await fetch("/apishifts/", { credentials: 'include' });
        const data = await response.json();
        setShifts(data);
        setfilteredShifts(data);
        setMapShifts(data);
      } catch (e) {}
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const shiftsState = useSelector(state => state.shifts);
  const fetchShifts = async() => {
    const response = await fetch("/apishifts/", { credentials: 'include' });
    const shifts = await response.json();
    setShifts(shifts);
    setfilteredShifts(shifts);
    setMapShifts(shifts);
    setIsLoading(false);
    // Preload all shifts only after today's shifts have rendered, and only if not already loaded/loading
    if (!shiftsState.loaded && !shiftsState.loading) {
      fetchAllShifts(dispatch);
    }
  }

  const redirectToShiftPage = (shift) => {
    const recordId = shift && shift[3] ? shift[3].value : null;
    if (recordId) {
      navigate(`/shift/${recordId}`, { state: { shift } });
    }
  }

  const handleChangeInput = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    if (!searchTerm) {
      setfilteredShifts(shifts);
      return;
    }
    const formatTime = formatDateTimeOrdinal;
    const filteredShifts = shifts.filter(item => {
      if (!item) return false;
      const fields = [
        item[378] ? item[378].value : '',
        item[321] ? item[321].value : '',
        item[898] ? item[898].value : '',
        item[6] ? formatTime(item[6].value) : '',
        item[7] ? formatTime(item[7].value) : '',
      ];
      return fields.some(val => val.toLowerCase().includes(searchTerm));
    });
    setfilteredShifts(filteredShifts)
  }

  if (isLoading) {
    return (
      <div className="shifts-home">
        <div className="locationsList">
          <h2>Todays Shifts</h2>
          <div className="skeleton-cell" style={{ width: '100%', height: '400px', borderRadius: '8px', marginBottom: '16px' }}></div>
          <div className="skeleton-wrapper">
            <table className="skeleton-table">
              <tbody>
                <tr>
                  <th>Vendor Name</th>
                  <th>Location Code</th>
                  <th>Status</th>
                  <th>Address</th>
                  <th>Armed/Unarmed</th>
                  <th>Guard Type</th>
                  <th>Temporary/Recurring</th>
                  <th>Shift Start (local time)</th>
                  <th>Shift End (local time)</th>
                </tr>
                {Array.from({ length: 15 }).map((_, idx) => (
                  <tr key={idx}>
                    {Array.from({ length: 9 }).map((_, colIdx) => (
                      <td key={colIdx}>
                        <div className={`skeleton-cell ${colIdx % 3 === 0 ? 'skeleton-cell-short' : colIdx % 3 === 1 ? 'skeleton-cell-medium' : 'skeleton-cell-long'}`}></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  return (
  <div className="shifts-home">
  <div className="locationsList">
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
      <h2>Todays Shifts</h2>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        {/* <button className="mainButton" onClick={() => navigate('/guardRequests/new')}>+ Add New Guard Request</button> */}
        {/* <button className="mainButton" onClick={() => navigate('/issues/new')}>+ Submit an Issue</button> */}
        {/* <button className="mainButton" onClick={handleDownloadSchedules}>Download Schedules</button> */}
        <ExcelButton
          rows={() => filteredShifts.map(shift => {
            const { statusText } = getShiftStatus(shift, defaultPinColor);
            return {
              'Vendor Name': shift && shift[378] ? shift[378].value : '',
              'Location Code': shift && shift[321] ? shift[321].value : '',
              'Status': statusText,
              'Address': shift && shift[898] ? shift[898].value : '',
              'Armed/Unarmed': shift && shift[107] ? shift[107].value : '',
              'Guard Type': shift && shift[108] ? shift[108].value : '',
              'Temporary/Recurring': shift && shift[1295] ? shift[1295].value : '',
              'Shift Start (local time)': shift && shift[6] ? formatDateTimeOrdinal(shift[6].value) : '',
              'Shift End (local time)': shift && shift[7] ? formatDateTimeOrdinal(shift[7].value) : '',
            };
          })}
          fileName="todays-shifts.xlsx"
          sheetName="Today's Shifts"
        />
      </div>
    </div>
  <ShiftMap shifts={mapShifts} defaultColor={defaultPinColor} onShiftClick={redirectToShiftPage} />
    <div className="searchInputWrapper inputWrapper">
      <input placeholder="Search records..." onChange={handleChangeInput}></input>
    </div>
    <p style={{color: '#666', fontSize: '14px', marginBottom: '10px', marginTop: '10px'}}>
      Showing {filteredShifts.length} of {shifts.length} shifts
    </p>
  <div className="tableScroll">
  <table id="tableWrapper">
  <tbody>
  <tr>
    <th>Vendor Name</th>
    <th>Location Code</th>
    <th>Status</th>
    <th className="addressCell">Address</th>
    <th>Armed/Unarmed</th>
    <th>Guard Type</th>
    <th>Temporary/Recurring</th>
    <th>Shift Start (local time)</th>
    <th>Shift End (local time)</th>
  </tr>
    {filteredShifts.length > 0 && [...filteredShifts].sort((a, b) => {
      const aStart = a && a[6] && a[6].value ? new Date(a[6].value).getTime() : Infinity;
      const bStart = b && b[6] && b[6].value ? new Date(b[6].value).getTime() : Infinity;
      return aStart - bStart;
    }).map((shift, idx) => {
      const formatTime = formatDateTimeOrdinal;
      const { statusText, statusColor } = getShiftStatus(shift, defaultPinColor);
      return (
        <tr key={idx} onClick={() => redirectToShiftPage(shift)} className="tableRow">
          <td className="tableCell">{shift && shift[378] ? shift[378].value : ""}</td>
          <td className="tableCell">{shift && shift[321] ? shift[321].value : ""}</td>
          <td className="tableCell">
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
              <span style={{ width: '14px', height: '14px', borderRadius: '50%', backgroundColor: statusColor, flexShrink: 0 }}></span>
              {statusText}
            </span>
          </td>
          <td className="tableCell addressCell">{shift && shift[898] ? shift[898].value : ""}</td>
          <td className="tableCell">{shift && shift[107] ? shift[107].value : ""}</td>
          <td className="tableCell">{shift && shift[108] ? shift[108].value : ""}</td>
          <td className="tableCell">{shift && shift[1295] ? shift[1295].value : ""}</td>
          <td className="tableCell">{shift && shift[6] ? formatTime(shift[6].value) : ""}</td>
          <td className="tableCell">{shift && shift[7] ? formatTime(shift[7].value) : ""}</td>
        </tr>
      )
    })}
    </tbody>
</table>
</div>
</div>
  </div>
  )
}